import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable(
   {
      providedIn: 'root'
   }
   
)
export class PrintService {

   constructor(private http: HttpClient) {}
       
   fnpostInputParams(url: any, params: any) {
      var headers = {
         'Access-Control-Allow-Origin': '*',
         //'Content-Type': "application/JSON",
         'authkey': (localStorage["renoerpadtoken"] === undefined) ? "1" : JSON.parse(localStorage["renoerpadtoken"])
      }
       return this.http.post('https://riapi.renoinfo.ae/' + url, params, { headers: headers });
      //return this.http.post('http://200.1.50.10:7003/' + url, params, { headers: headers });
      
   }

   getPrintInvoice(params: any) {
    return this.fnpostInputParams('report/getprintinvoice', params);
 }
}
